import { useState } from "react";
import { Eye, Image, FileText, Video } from "lucide-react";
import { fmtNum } from "@/shared/lib/format";
import type { PostData } from "../mockData";

function PostCard({ post }: { post: PostData }) {
  const Icon = post.type === "photo" ? Image : post.type === "video" ? Video : FileText;
  return (
    <div className="rounded-md overflow-hidden transition-colors hover:border-ink-40/30 cursor-pointer"
      style={{ border: "0.5px solid rgba(28,28,28,0.12)" }}>
      <div className="aspect-video bg-ink-6 flex items-center justify-center">
        <Icon size={20} className="text-ink-40" />
      </div>
      <div className="p-[6px_8px]">
        <p className="text-[11px] text-ink line-clamp-2 leading-snug mb-1.5">{post.excerpt}</p>
        <div className="flex items-center gap-2 text-[10px] text-ink-40">
          <Eye size={10} />
          <span className="font-mono">{fmtNum(post.views)}</span>
          <span>·</span>
          <span>{post.date}</span>
        </div>
      </div>
    </div>
  );
}

function ActivitySummary({ posts }: { posts: PostData[] }) {
  const postsPerWeek = (posts.length / 3).toFixed(1);
  const adPosts = Math.round(posts.length * 0.3);
  const items = [
    { v: postsPerWeek, label: "постов/нед",    accent: false },
    { v: "вт–чт",     label: "пиковые дни",   accent: false },
    { v: "18–21",     label: "лучшее время",  accent: false },
    { v: String(adPosts), label: "рекл./мес", accent: true },
  ];
  return (
    <div className="flex items-stretch mb-4 rounded-md bg-white border border-ink-12 overflow-hidden">
      {items.map((item, i) => (
        <div key={i} className="flex-1 flex flex-col items-center py-2.5 px-3"
          style={{ borderRight: i < items.length - 1 ? "0.5px solid rgba(28,28,28,0.12)" : "none" }}>
          <span className="font-display font-bold text-[16px] leading-tight"
            style={item.accent ? { color: "#27500A" } : {}}>
            {item.v}
          </span>
          <span className="text-[10px] text-ink-40 mt-0.5">{item.label}</span>
        </div>
      ))}
    </div>
  );
}

export function PostsTab({ posts }: { posts: PostData[] }) {
  const [shown, setShown] = useState(6);
  return (
    <div>
      <ActivitySummary posts={posts} />
      <div className="grid grid-cols-3 gap-[7px]">
        {posts.slice(0, shown).map((p) => <PostCard key={p.id} post={p} />)}
      </div>
      {shown < posts.length && (
        <div className="flex justify-center mt-4">
          <button onClick={() => setShown((n) => n + 6)}
            className="h-8 px-5 rounded-pill border border-ink-12 text-[12px] font-display font-semibold hover:border-ink/40">
            Показать ещё
          </button>
        </div>
      )}
    </div>
  );
}
